module.exports = __webpack_public_path__ + "static/media/20-5.4e581d1c.mp3";